import Grid from '@material-ui/core/Grid';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import LinkExpiredIcon from '@serko/zui-icons/es/LinkExpiredIcon';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import messages from '../intl/messages';
import { EmptyState } from './lab/EmptyState';

interface OwnProps {}

interface LinkExpiredProps extends OwnProps, WithStyles, InjectedIntlProps {}

const LinkExpiredBase: FunctionComponent<LinkExpiredProps> = (
  props: LinkExpiredProps,
) => {
  const {
    classes,
    intl: { formatMessage },
  } = props;
  return (
    <Grid
      container
      alignItems="center"
      justify="center"
      className={classes.container}
    >
      <Grid item xs={12}>
        <EmptyState
          icon={<LinkExpiredIcon />}
          headingSize="sm"
          iconSize="sm"
          heading={formatMessage(messages.linkExpired.title)}
          message={formatMessage(messages.linkExpired.description)}
        />
      </Grid>
    </Grid>
  );
};

// styled
const styles = createStyles({
  container: {
    flexGrow: 1,
    minHeight: '100%',
  },
});

/**
 * Error message that displays when the current itinerary is no longer available (or if not found).
 *
 * @see EmptyState - based on 'lab' component called `EmptyState`
 */
export const LinkExpired = compose<LinkExpiredProps, {}>(
  withStyles(styles),
  injectIntl,
)(LinkExpiredBase);

LinkExpired.displayName = 'LinkExpired';
